var map = {
	"./account.svg": "2b35",
	"./arrow-select.svg": "1f73",
	"./arrow.svg": "60ae",
	"./bell.svg": "3cc2",
	"./calendar.svg": "aa21",
	"./document-big.svg": "67f5",
	"./document.svg": "c47c",
	"./download.svg": "10ae",
	"./file-fill.svg": "0b5d",
	"./file.svg": "f37c",
	"./globe.svg": "6d6f",
	"./google.svg": "4225",
	"./home-big.svg": "1010",
	"./lesson.svg": "7a73",
	"./logo.svg": "d191",
	"./minus.svg": "7e44",
	"./msg.svg": "1465",
	"./passHide.svg": "4736",
	"./passShow.svg": "e6bf",
	"./perform-fill.svg": "1e80",
	"./perform.svg": "0fda",
	"./plus.svg": "871b",
	"./reset.svg": "8231",
	"./security.svg": "22b8",
	"./settings-fill.svg": "8a22",
	"./settings.svg": "1f0e",
	"./terms.svg": "c37a",
	"./user-big.svg": "5643",
	"./view.svg": "ff8f",
	"./wallet-big.svg": "3539",
	"./wallet-fill.svg": "ac45",
	"./wallet.svg": "44f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7906";